/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Legacy
 * Mercatus Legacy ILM
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { InlineResponse200 } from '../model';
// @ts-ignore
import { InlineResponse2001 } from '../model';
/**
 * ModelApi - axios parameter creator
 * @export
 */
export const ModelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Fetch models for entity
         * @param {number} entityId Entity id to fetch models for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchModelsForEntity: async (entityId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('fetchModelsForEntity', 'entityId', entityId)
            const localVarPath = `/projectDetail/fetchModels/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update default model evaluation
         * @param {number} entityId Entity id to update.
         * @param {string} ts timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultModelEvaluationForEntity: async (entityId: number, ts: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('updateDefaultModelEvaluationForEntity', 'entityId', entityId)
            // verify required parameter 'ts' is not null or undefined
            assertParamExists('updateDefaultModelEvaluationForEntity', 'ts', ts)
            const localVarPath = `/projectDetail/updateEvaluation/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ts !== undefined) {
                localVarQueryParameter['ts'] = ts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update model evaluation
         * @param {number} entityId Entity id to update.
         * @param {number} modelId Model id of this entity to update.
         * @param {string} ts timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModelEvaluationForEntity: async (entityId: number, modelId: number, ts: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('updateModelEvaluationForEntity', 'entityId', entityId)
            // verify required parameter 'modelId' is not null or undefined
            assertParamExists('updateModelEvaluationForEntity', 'modelId', modelId)
            // verify required parameter 'ts' is not null or undefined
            assertParamExists('updateModelEvaluationForEntity', 'ts', ts)
            const localVarPath = `/projectDetail/updateEvaluation/project/{entityId}/model/{modelId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"modelId"}}`, encodeURIComponent(String(modelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ts !== undefined) {
                localVarQueryParameter['ts'] = ts;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelApi - functional programming interface
 * @export
 */
export const ModelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Fetch models for entity
         * @param {number} entityId Entity id to fetch models for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fetchModelsForEntity(entityId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fetchModelsForEntity(entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update default model evaluation
         * @param {number} entityId Entity id to update.
         * @param {string} ts timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDefaultModelEvaluationForEntity(entityId: number, ts: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDefaultModelEvaluationForEntity(entityId, ts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update model evaluation
         * @param {number} entityId Entity id to update.
         * @param {number} modelId Model id of this entity to update.
         * @param {string} ts timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateModelEvaluationForEntity(entityId: number, modelId: number, ts: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateModelEvaluationForEntity(entityId, modelId, ts, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ModelApi - factory interface
 * @export
 */
export const ModelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelApiFp(configuration)
    return {
        /**
         * 
         * @summary Fetch models for entity
         * @param {number} entityId Entity id to fetch models for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchModelsForEntity(entityId: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.fetchModelsForEntity(entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update default model evaluation
         * @param {number} entityId Entity id to update.
         * @param {string} ts timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDefaultModelEvaluationForEntity(entityId: number, ts: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.updateDefaultModelEvaluationForEntity(entityId, ts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update model evaluation
         * @param {number} entityId Entity id to update.
         * @param {number} modelId Model id of this entity to update.
         * @param {string} ts timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateModelEvaluationForEntity(entityId: number, modelId: number, ts: string, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.updateModelEvaluationForEntity(entityId, modelId, ts, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModelApi - object-oriented interface
 * @export
 * @class ModelApi
 * @extends {BaseAPI}
 */
export class ModelApi extends BaseAPI {
    /**
     * 
     * @summary Fetch models for entity
     * @param {number} entityId Entity id to fetch models for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public fetchModelsForEntity(entityId: number, options?: any) {
        return ModelApiFp(this.configuration).fetchModelsForEntity(entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update default model evaluation
     * @param {number} entityId Entity id to update.
     * @param {string} ts timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public updateDefaultModelEvaluationForEntity(entityId: number, ts: string, options?: any) {
        return ModelApiFp(this.configuration).updateDefaultModelEvaluationForEntity(entityId, ts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update model evaluation
     * @param {number} entityId Entity id to update.
     * @param {number} modelId Model id of this entity to update.
     * @param {string} ts timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelApi
     */
    public updateModelEvaluationForEntity(entityId: number, modelId: number, ts: string, options?: any) {
        return ModelApiFp(this.configuration).updateModelEvaluationForEntity(entityId, modelId, ts, options).then((request) => request(this.axios, this.basePath));
    }
}
